/**
* 
* isdPassword
*/
import React, { useState } from "react";
import IsdTextBox from "../common/isdTextBox";
import { observer } from "mobx-react";
import errMsgService from "../../services/common/errMsgService";
import { isEmpty } from "../../util/util";
import stateStore from "../../store/stateStore";
const IsdPassword = observer(React.forwardRef((props, ref) => {
    // エラー状態を判別するstate
    const [isError, setIsError] = useState(false);

    // ロストフォーカスイベント
    const onBlur = (event) => {
        let errorCounter = 0;

        // 親コンポーネントのvalueを取得する
        let pValue = stateStore.state[props.name];

        // props.ruleに関数が指定されている場合、その関数を実行
        if (!!props.rule && typeof props.rule === 'function') {
            // 関数実行結果がfalseの場合、エラーメッセージ登録
            if (!props.rule(pValue)) {
                // エラーメッセージ登録
                errorCounter++;
                errMsgService.addMsgLabel("ECMN1470", props);
            }
        }

        // props.ruleに文字列が指定されている場合、その文字列で正規表現チェックを行う
        if (!!props.rule && typeof props.rule === 'string') {
            let regexp = new RegExp(props.rule, 'g')
            if (!pValue.match(regexp)) {
                // エラーメッセージ登録
                errorCounter++;
                errMsgService.addMsgLabel("ECMN1480", props);
            }
        }

        // props.ruleが、関数でも文字列でもなかった場合、エラーメッセージを登録する
        if (!!props.rule && typeof props.rule !== 'function' && typeof props.rule !== 'string') {
            // エラーメッセージ登録
            errorCounter++;
            errMsgService.addMsgLabel("ECMN1490", props);
        }

        // エラーの有無でisErrorの状態を更新する
        if (errorCounter > 0 && !isError) {
            setIsError(true);
        } else if (isError) {
            errMsgService.delMsgLabel(props);
            setIsError(false);
        }

        // props.onBlur実行
        if (!!props.onBlur) {
            props.onBlur(event);
        }
    }

    // classNameの生成
    // className属性を格納する配列を宣言
    let classNameArray = [];
    // propsにclassNameが指定されている場合、classNameに追加
    if (!!props.className && !isEmpty(props.className)) {
        classNameArray.push(props.className);
    }
    // エラーが1個以上で、propsにdisabledが指定されていなければ、classNameに"error-place"を追加
    if (!props.disabled && isError) {
        classNameArray.push("error-place");
    }
    // 配列classNameArrayの要素からclassNameを生成する
    let className = classNameArray.join(" ");

    return (
        <>
            <IsdTextBox
                isdmaxlength={props.isdmaxlength}
                required={props.required ? 'required' : ''}
                disabled={props.disabled ? 'disabled' : ''}
                type='password'
                className={className}
                id={props.id}
                name={props.name}
                value={props.value}
                placeholder={props.placeholder}
                ref={ref}
                onBlur={onBlur} onChange={props.onChange}
            />
        </>
    );
}))

export default IsdPassword;
